import { Moon, Sun } from 'lucide-react';
import { Button } from '@/ui/button';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

export default function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('w-full justify-center sm:w-auto', className)}
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? (
        <>
          <Sun className="mr-2 h-4 w-4" />
          Light
        </>
      ) : (
        <>
          <Moon className="mr-2 h-4 w-4" />
          Dark
        </>
      )}
    </Button>
  );
}
